import { trackClick } from '@marketplace/helpers/segment/index.js'
import throttle from 'lodash/throttle'

export default {
    data() {
        return {
            slidesSeenOnMobile: 0,
        }
    },
    methods: {
        /**
         * Every couple seconds sends a throttled segment tracking
         * Tracks how many slides where seen on mobile and how much has been slided
         */
        onMobileSlide: throttle(function () {
            const {
                page = '',
                listName = '',
                action = '',
                sliderName = '',
                sliderId = '',
            } = this.tracking || ''

            const sliderArea = this.$refs[`currentSlider-${this.refID}`]
            if (!sliderArea) return

            const sliderWidth = sliderArea.scrollWidth
            const singleSlidePercentage = sliderArea.children[0].offsetWidth
            const maxSlidesToSee = parseInt(sliderWidth / singleSlidePercentage)
            const amountScrolled = sliderArea.scrollLeft
            const slidesSeen = Math.ceil(
                (amountScrolled + singleSlidePercentage) / singleSlidePercentage
            )
            const displayedSliderName = sliderName || listName || action

            if (slidesSeen > this.slidesSeenOnMobile) {
                this.trackMobileSwiping(
                    slidesSeen,
                    maxSlidesToSee,
                    displayedSliderName,
                    page,
                    action,
                    sliderId
                )
            }
            if (maxSlidesToSee === this.slidesSeenOnMobile) {
                this.trackMobileAllSlidesSeenOn(
                    displayedSliderName,
                    page,
                    action,
                    sliderId
                )
            }
        }, 1500),
        trackMobileSwiping(seen, max, name, page, action, sliderId) {
            this.slidesSeenOnMobile = seen
            trackClick(
                `Slider Mobile Swipe`,
                {
                    category: 'Mobile',
                    slidesSeen: seen,
                    maxSlides: max,
                    percentageSeen: `${Math.floor((seen / max) * 100)}%`,
                    page,
                    sliderName: name,
                    action,
                    sliderId,
                },
                ''
            )
        },
        trackMobileAllSlidesSeenOn(name, page, action, sliderId) {
            this.$refs[`currentSlider-${this.refID}`].removeEventListener(
                'scroll',
                this.onMobileSlide
            )
            trackClick(
                `Slider Mobile Swipe - End Reached`,
                {
                    category: 'Mobile',
                    slidesSeen: this.slidesSeenOnMobile,
                    page,
                    sliderName: name,
                    action,
                    sliderId,
                },
                ''
            )
        },
        trackSliderArrow(tracking, direction) {
            if (!tracking || !Object.keys(tracking)) return

            const name =
                tracking?.sliderName || tracking?.listName || tracking?.action
            const category = tracking?.category || tracking?.page

            trackClick(`Slider Arrow`, {
                category: category || 'Unknown',
                label: direction,
                sliderName: name,
                action: tracking.action,
                sliderId: tracking.sliderId,

                ...tracking,
            })
        },
    },
}
